import React, { useEffect } from "react";
import { ORCHID_LOGO } from "@/lib/brand";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

const PROPERTIES = [
    { name: "The Orchid Mumbai · Vile Parle", city: "Mumbai, Maharashtra", img: "https://orchidhotel.com/static/website/img/Main-Home-page/Our-Hotel/Mumbai-Vile-Parle.webp" },
    { name: "The Orchid Pune", city: "Pune, Maharashtra", img: "https://orchidhotel.com/static/website/img/Main-Home-page/Our-Hotel/Orchid-Pune.webp" },
    { name: "The Orchid Shimla", city: "Shimla, Himachal Pradesh", img: "https://orchidhotel.com/static/website/img/Main-Home-page/Our-Hotel/Orchid-Shimla.webp" },
    { name: "The Orchid Manali", city: "Manali, Himachal Pradesh", img: "https://orchidhotel.com/static/website/img/Main-Home-page/Our-Hotel/The-Orchid-Manali.webp" },
    { name: "The Orchid Lonavala", city: "Lonavala, Maharashtra", img: "https://orchidhotel.com/static/website/img/Main-Home-page/Our-Hotel/The-Orchid-Lonavala.webp" },
    { name: "Fort JadhavGADH", city: "Pune (Heritage Fort)", img: "https://orchidhotel.com/static/website/img/Main-Home-page/Our-Hotel/Fort-JadhavGADH.webp" },
    { name: "Lotus Eco Beach Resort, Konark", city: "Konark, Odisha", img: "https://orchidhotel.com/static/website/img/Main-Home-page/Our-Hotel/Konark.webp" },
    { name: "The Orchid Passaros, Goa", city: "Benaulim, South Goa", img: "https://orchidhotel.com/static/website/img/Main-Home-page/Our-Hotel/Orchid-Goa-Passaros.webp" },
    { name: "Mahodadhi Palace, Puri", city: "Puri, Odisha", img: "https://orchidhotel.com/static/website/img/MAHODADH.webp" },
];

const OFFERS = [
    { title: "Honeymoon Escape", desc: "Romantic suites · Candle-lit dining · Couple's spa", img: "https://www.orchidhotel.com/static/website/images/home/offers/honeymoon-offer.webp" },
    { title: "Luxury Weekend", desc: "Stay 2 pay 1 · Free upgrade · Late checkout", img: "https://www.orchidhotel.com/static/website/images/home/offers/luxury-weekend.webp" },
    { title: "Destination Weddings", desc: "Heritage forts · Beach resorts · Custom menus", img: "https://www.orchidhotel.com/static/website/images/home/offers/wedding-offer.webp" },
];

const HERO_IMG =
    "https://images.unsplash.com/photo-1724947052687-e580b3010aad?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwyfHxpbmRpYW4lMjBoZXJpdGFnZSUyMGx1eHVyeSUyMHJlc29ydHxlbnwwfHx8fDE3Nzk4MDI4ODN8MA&ixlib=rb-4.1.0&q=85";

export default function OrchidDemo() {
    useEffect(() => {
        // Inject the production-equivalent embed snippet
        if (window.__orchidConciergeLoaded) return;
        const s = document.createElement("script");
        s.async = true;
        s.src = `${BACKEND}/api/widget.js`;
        s.setAttribute("data-testid", "orchid-embed-script");
        document.body.appendChild(s);
        return () => {
            // Best-effort cleanup on route change
            document.querySelectorAll(".orchid-cc-bubble, .orchid-cc-frame, .orchid-cc-toast").forEach((el) => el.remove());
            try { delete window.__orchidConciergeLoaded; } catch (e) { window.__orchidConciergeLoaded = false; }
        };
    }, []);

    return (
        <div className="min-h-screen bg-white text-stone-900 font-sans">
            {/* Demo banner */}
            <div className="bg-orchid-950 text-ivory text-xs py-2 px-4 text-center">
                <span className="opacity-80">Demo preview · the live chat bubble in the bottom-right is the deployable widget — try it.</span>
            </div>

            {/* Header */}
            <header className="border-b border-stone-200 bg-white sticky top-0 z-30">
                <div className="max-w-7xl mx-auto px-6 py-3 flex items-center justify-between">
                    <a href="#" className="flex items-center gap-3" data-testid="demo-brand">
                        <img
                            src={ORCHID_LOGO}
                            alt="The Orchid Hotels"
                            className="h-14 w-auto"
                        />
                    </a>
                    <nav className="hidden md:flex items-center gap-8 text-sm font-medium text-stone-700">
                        <a className="hover:text-orchid-700">Our Hotels</a>
                        <a className="hover:text-orchid-700">Orchid Rewards</a>
                        <a className="hover:text-orchid-700">Restaurants</a>
                        <a className="hover:text-orchid-700">Banquets</a>
                        <a className="hover:text-orchid-700">Wedding</a>
                        <a className="hover:text-orchid-700">Contact</a>
                    </nav>
                    <a
                        href="#"
                        className="bg-orchid-700 hover:bg-orchid-600 text-white text-sm font-medium px-5 py-2.5 rounded-md transition-colors"
                        data-testid="demo-book-now"
                    >
                        BOOK NOW
                    </a>
                </div>
            </header>

            {/* Hero */}
            <section className="relative overflow-hidden">
                <div
                    className="absolute inset-0"
                    style={{
                        backgroundImage: `url("${HERO_IMG}")`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                    }}
                />
                <div
                    className="absolute inset-0"
                    style={{
                        background:
                            "linear-gradient(120deg, rgba(2,44,34,0.85) 0%, rgba(6,78,59,0.55) 55%, rgba(2,44,34,0.2) 100%)",
                    }}
                />
                <div className="relative max-w-7xl mx-auto px-6 py-32 lg:py-40 text-ivory">
                    <div className="text-[11px] uppercase tracking-[0.3em] text-gold-400 mb-4">
                        Asia&apos;s First Eco-Luxury Hotel Chain · Since 1986
                    </div>
                    <h1 className="font-heading text-5xl lg:text-7xl leading-[1.05] max-w-3xl">
                        Where India&apos;s finest stays
                        <br />
                        <em className="text-gold-400 not-italic">welcome you home.</em>
                    </h1>
                    <p className="mt-6 max-w-xl text-stone-200 leading-relaxed">
                        Heritage forts, hill-station retreats, beachfront escapes, and city sanctuaries —
                        a portfolio of 25+ award-winning properties across India, each rooted in sustainable luxury.
                    </p>
                    <div className="mt-10 flex flex-wrap gap-4">
                        <a href="#properties" className="bg-gold-500 hover:bg-gold-600 text-orchid-950 font-medium px-7 py-3.5 rounded-md transition-colors">
                            Explore our hotels
                        </a>
                        <a href="#rewards" className="border border-ivory/40 hover:bg-white/10 text-ivory font-medium px-7 py-3.5 rounded-md transition-colors">
                            Orchid Rewards
                        </a>
                    </div>
                </div>
            </section>

            {/* Numbers */}
            <section className="bg-stone-50 border-y border-stone-200">
                <div className="max-w-7xl mx-auto px-6 py-12 grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
                    {[
                        ["07", "Brands"],
                        ["95+", "Years of Legacy"],
                        ["90+", "Awards Won"],
                        ["2500+", "Rooms Across India"],
                    ].map(([n, l]) => (
                        <div key={l}>
                            <div className="font-heading text-5xl text-orchid-700">{n}</div>
                            <div className="mt-1 text-xs uppercase tracking-[0.2em] text-stone-500">{l}</div>
                        </div>
                    ))}
                </div>
            </section>

            {/* Properties */}
            <section id="properties" className="max-w-7xl mx-auto px-6 py-20">
                <div className="flex items-end justify-between mb-12">
                    <div>
                        <div className="text-xs uppercase tracking-[0.25em] text-gold-700 mb-2">Our Hotels</div>
                        <h2 className="font-heading text-5xl text-orchid-700">A property for every story.</h2>
                    </div>
                    <a className="hidden md:inline text-sm font-medium text-orchid-700 hover:underline">
                        View all 25+ properties →
                    </a>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                    {PROPERTIES.map((p) => (
                        <a
                            key={p.name}
                            href="#"
                            data-testid={`prop-${p.name}`}
                            className="group rounded-lg overflow-hidden border border-stone-200 bg-white hover:shadow-lift transition-shadow"
                        >
                            <div className="aspect-[4/3] overflow-hidden bg-stone-100">
                                <img
                                    src={p.img}
                                    alt={p.name}
                                    loading="lazy"
                                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                                    onError={(e) => { e.currentTarget.src = "https://images.unsplash.com/photo-1566073771259-6a8506099945?w=800&q=80"; }}
                                />
                            </div>
                            <div className="p-5">
                                <div className="font-heading text-2xl text-orchid-700 leading-tight">{p.name}</div>
                                <div className="text-sm text-stone-500 mt-1">{p.city}</div>
                                <div className="mt-4 text-xs uppercase tracking-[0.2em] text-gold-700 group-hover:underline">
                                    Explore →
                                </div>
                            </div>
                        </a>
                    ))}
                </div>
            </section>

            {/* Rewards */}
            <section id="rewards" className="bg-orchid-950 text-ivory">
                <div className="max-w-7xl mx-auto px-6 py-20 grid lg:grid-cols-2 gap-16 items-center">
                    <div>
                        <div className="text-xs uppercase tracking-[0.3em] text-gold-400 mb-3">
                            Orchid Rewards
                        </div>
                        <h2 className="font-heading text-5xl leading-tight">
                            Earn <em className="text-gold-400 not-italic">Petals</em>. <br />
                            Stay <em className="text-gold-400 not-italic">unforgettably</em>.
                        </h2>
                        <p className="mt-6 text-stone-300 leading-relaxed max-w-md">
                            Every direct booking earns you Petals — redeemable for stays, dining, spa, and exclusive
                            member-only experiences across all Orchid properties.
                            <br />
                            <span className="text-gold-400">1 Petal = ₹1</span> at properties · <span className="text-gold-400">2 Petals = ₹1</span> at the Rewards Store.
                        </p>
                        <div className="mt-8 flex flex-wrap gap-3">
                            <a className="bg-gold-500 hover:bg-gold-600 text-orchid-950 font-medium px-6 py-3 rounded-md transition-colors">
                                Join Free
                            </a>
                            <a className="border border-ivory/30 hover:bg-white/10 text-ivory font-medium px-6 py-3 rounded-md transition-colors">
                                Check My Petals
                            </a>
                        </div>
                    </div>
                    <div className="grid grid-cols-3 gap-4">
                        {[
                            { tier: "Silver", pct: "5%", color: "bg-stone-700" },
                            { tier: "Gold", pct: "8%", color: "bg-gold-700" },
                            { tier: "Platinum", pct: "12%", color: "bg-orchid-600" },
                        ].map((p) => (
                            <div key={p.tier} className={`${p.color} rounded-lg p-6 text-center`}>
                                <div className="font-heading text-3xl">{p.tier}</div>
                                <div className="text-xs uppercase tracking-[0.2em] text-ivory/70 mt-1">
                                    Earn Rate
                                </div>
                                <div className="font-heading text-5xl text-gold-400 mt-4">{p.pct}</div>
                                <div className="text-xs text-ivory/60 mt-1">on every stay</div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Offers */}
            <section className="max-w-7xl mx-auto px-6 py-20">
                <div className="text-xs uppercase tracking-[0.25em] text-gold-700 mb-2">Limited-time</div>
                <h2 className="font-heading text-5xl text-orchid-700 mb-12">Curated offers, just for you.</h2>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    {OFFERS.map((o) => (
                        <div
                            key={o.title}
                            className="rounded-lg overflow-hidden border border-stone-200 bg-white hover:shadow-lift transition-shadow"
                        >
                            <div className="aspect-[5/3] overflow-hidden bg-stone-100">
                                <img
                                    src={o.img}
                                    alt={o.title}
                                    loading="lazy"
                                    className="w-full h-full object-cover"
                                    onError={(e) => { e.currentTarget.style.display = "none"; }}
                                />
                            </div>
                            <div className="p-6">
                                <div className="font-heading text-2xl text-orchid-700">{o.title}</div>
                                <div className="text-sm text-stone-600 mt-2">{o.desc}</div>
                                <div className="mt-4 text-xs uppercase tracking-[0.2em] text-gold-700">
                                    View offer →
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </section>

            {/* Eco */}
            <section className="bg-stone-50 border-t border-stone-200">
                <div className="max-w-5xl mx-auto px-6 py-20 text-center">
                    <div className="text-xs uppercase tracking-[0.3em] text-gold-700 mb-3">
                        Asia&apos;s First Ecotel
                    </div>
                    <h2 className="font-heading text-5xl text-orchid-700 leading-tight">
                        Luxury, with a lighter footprint.
                    </h2>
                    <p className="mt-6 text-stone-600 max-w-2xl mx-auto leading-relaxed">
                        Since 1986, The Orchid has pioneered eco-luxury hospitality in India — solar power,
                        rainwater harvesting, zero-waste kitchens, and green infrastructure across every property.
                        Indulgence and responsibility, beautifully reconciled.
                    </p>
                </div>
            </section>

            {/* Footer */}
            <footer className="bg-orchid-950 text-ivory">
                <div className="max-w-7xl mx-auto px-6 py-14 grid md:grid-cols-4 gap-10">
                    <div>
                        <div className="font-heading text-2xl text-gold-400">The Orchid Hotels</div>
                        <p className="text-sm text-stone-300 mt-4 leading-relaxed">
                            Asia&apos;s first eco-luxury 5-star hotel chain. 25+ properties across India.
                        </p>
                    </div>
                    <div>
                        <div className="text-xs uppercase tracking-[0.25em] text-gold-400 mb-3">Explore</div>
                        <ul className="space-y-2 text-sm text-stone-300">
                            <li><a className="hover:text-ivory">Our Hotels</a></li>
                            <li><a className="hover:text-ivory">Restaurants</a></li>
                            <li><a className="hover:text-ivory">Banquets & Events</a></li>
                            <li><a className="hover:text-ivory">Weddings</a></li>
                        </ul>
                    </div>
                    <div>
                        <div className="text-xs uppercase tracking-[0.25em] text-gold-400 mb-3">Rewards</div>
                        <ul className="space-y-2 text-sm text-stone-300">
                            <li><a className="hover:text-ivory">Join Orchid Rewards</a></li>
                            <li><a className="hover:text-ivory">Compare Plans</a></li>
                            <li><a className="hover:text-ivory">Check My Petals</a></li>
                            <li><a className="hover:text-ivory">Rewards Store</a></li>
                        </ul>
                    </div>
                    <div>
                        <div className="text-xs uppercase tracking-[0.25em] text-gold-400 mb-3">Contact</div>
                        <ul className="space-y-2 text-sm text-stone-300">
                            <li>+91 916 916 6789</li>
                            <li>reservations@orchidhotel.com</li>
                            <li>helpdesk@orchidrewards.in</li>
                        </ul>
                    </div>
                </div>
                <div className="border-t border-white/10">
                    <div className="max-w-7xl mx-auto px-6 py-5 text-xs text-stone-400 flex flex-wrap justify-between items-center gap-3">
                        <div>© {new Date().getFullYear()} The Orchid Hotels · Kamat Hotels India.</div>
                        <div className="text-gold-400/80">Demo page · Concierge embed live</div>
                    </div>
                </div>
            </footer>
        </div>
    );
}
